var map = {
	"./bait-and-switch.jpg": "f751",
	"./confirmshaming.png": "92ad",
	"./disguised-ads.jpg": "315d",
	"./friend-spam.png": "9219",
	"./hidden-costs.png": "c9ea",
	"./price-comparison-prevention.png": "5987",
	"./price-zuckering.png": "3a69",
	"./roach-motel.png": "386d",
	"./sneak-into-basket.png": "3814",
	"./trick-question.jpg": "427e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba1a";